import React, { Component } from 'react';
import Paper from 'material-ui/Paper';
import RoomControlMain from '../../../../components/rooms/RoomControlMain'
import Page404 from '../../../../routes/404'

import { rooms as ROLES_CONFIG } from '../../../../config/roles';
import { Tabs } from 'material-ui';
import { Tab } from 'material-ui/Tabs';

import NewRemote from '../../../../components/remotes/NewRemote';
import AllRemotes from '../../../../components/remotes/AllRemotes';

import NewScene from '../../../../components/scenes/NewScene';
import AllScenes from '../../../../components/scenes/AllScenes';

import NewThermostat from '../../../../components/thermostats/NewThermostat';
import AllThermostats from '../../../../components/thermostats/AllThermostats';

import RoomEnergyMeter from '../../../../components/energymeter/RoomEnergyMeter';

export default class RoomControl extends Component {

  constructor(props) {
    super(props);
    this.state = {
      role: this.props.authenticated ? this.props.authenticated.role : null,
      _id: this.props && this.props.match && this.props.match.params ? this.props.match.params.id : ''
    }
  }

  render() {
    return (
      <div id="content">
        <div className="row">
          <Tabs className="tabs-container">
            {
              ROLES_CONFIG.roomControl.indexOf(this.state.role) != -1 ?
                <Tab label="Switches" className="tab">
                  <Paper className="col-md-12 col-12 h-100  p-0 customShadow" zDepth={3}>
                    {this.state._id && this.state._id.split && this.state._id.split('_') ? <RoomControlMain room_id={this.state._id.split('_')[0]} /> : <Page404 />}
                  </Paper>
                </Tab>
              : null
            }

            {
              ROLES_CONFIG.manageRemotes.indexOf(this.state.role) != -1 ?
                <Tab label="Remotes" className="tab">
                  <Paper className="col-md-12 col-12 h-100 p-0 customShadow" zDepth={3}>
                    {
                      this.state._id && this.state._id.split && this.state._id.split('_') ? 
                        <div>
                          <div className="col-md-4" style={{ padding: "1vw", paddingLeft: '2vw' }}>
                            <NewRemote room_id={this.state._id.split('_')[0]} room_main_id={this.state._id.split('_')[1]} />
                          </div>

                          <div className="col-md-8" 
                            style={{ paddingLeft: '0vw', paddingRight: '2vw', paddingTop: '1vw', paddingBottom: '1vw' }}
                          >
                            <AllRemotes room_id={this.state._id.split('_')[0]} room_main_id={this.state._id.split('_')[1]} />
                          </div>
                        </div> 
                      : 
                      <Page404 />
                    }
                  </Paper>
                </Tab>
              : null
            }

            {
              ROLES_CONFIG.manageScenes.indexOf(this.state.role) != -1 ?
                <Tab label="Scenes" className="tab">
                  <Paper className="col-md-12 col-12 h-100 p-0 customShadow" zDepth={3}>
                    {
                      this.state._id && this.state._id.split && this.state._id.split('_') ? 
                        <div>
                          <div className="col-md-4" style={{ padding: "1vw", paddingLeft: '2vw' }}>
                            <NewScene room_id={this.state._id.split('_')[0]} room_main_id={this.state._id.split('_')[1]} />
                          </div>

                          <div className="col-md-8" 
                            style={{ paddingLeft: '0vw', paddingRight: '2vw', paddingTop: '1vw', paddingBottom: '1vw' }}
                          >
                            <AllScenes room_id={this.state._id.split('_')[0]} room_main_id={this.state._id.split('_')[1]} />
                          </div>
                        </div> 
                      : 
                      <Page404 />
                    }
                  </Paper>
                </Tab>
              : null
            }

            {
              ROLES_CONFIG.manageThermostats.indexOf(this.state.role) != -1 ?
                <Tab label="Thermostats" className="tab">
                  <Paper className="col-md-12 col-12 h-100 p-0 customShadow" zDepth={3}>
                    {
                      this.state._id && this.state._id.split && this.state._id.split('_') ?
                        <div>
                          <div className="col-md-4" style={{ padding: "1vw", paddingLeft: '2vw' }}>
                            <NewThermostat room_id={this.state._id.split('_')[0]} room_main_id={this.state._id.split('_')[1]} />
                          </div>

                          <div className="col-md-8"
                            style={{ paddingLeft: '0vw', paddingRight: '2vw', paddingTop: '1vw', paddingBottom: '1vw' }}
                          >
                            <AllThermostats room_id={this.state._id.split('_')[0]} room_main_id={this.state._id.split('_')[1]} />
                          </div>
                        </div>
                      :
                      <Page404 />
                    }
                  </Paper>
                </Tab>
              : null
            }


            {
              ROLES_CONFIG.manageEnergyMeter.indexOf(this.state.role) != -1 ?
                <Tab label="Energy Meter" className="tab">
                  <Paper className="col-md-12 col-12 h-100 p-0 customShadow" zDepth={3}>
                    {
                      this.state._id && this.state._id.split && this.state._id.split('_') ?
                        <div>
                          <div className="col-md-12"
                            style={{ paddingLeft: '2vw', paddingRight: '2vw', paddingTop: '1vw', paddingBottom: '1vw' }}
                          >
                            <RoomEnergyMeter room_id={this.state._id.split('_')[0]} room_main_id={this.state._id.split('_')[1]} />
                          </div>
                        </div>
                      :
                      <Page404 />
                    }
                  </Paper>
                </Tab>
              : null
            }

          </Tabs>
        </div>
      </div>
    )
  }
} 


// WEBPACK FOOTER //
// ./routes/app/routes/rooms/RoomControl.js